module.exports = __webpack_public_path__ + "static/media/Bettair_Logo_Blue.b967532e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Bettair_Logo_Blue.png
// module id = 1068
// module chunks = 0